/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: SummaryofSalesbyYearListComponent
 * Purpose		: This component retrieve paged data and performs paging operations
 * Dependency	: SummaryofSalesbyYearService
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { Component, HostBinding, EventEmitter, Input, Output, OnInit, ViewChild,
	trigger, transition, animate,
	style, state } from '@angular/core';
import 'rxjs/add/operator/switchMap';
import { Observable } from 'rxjs/Observable';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ToastsManager }  from 'ng2-toastr';
import myGlobals = require('../globals');

import { SummaryofSalesbyYearData, SummaryofSalesbyYearService } from './SummaryofSalesbyYear.service';
import { SummaryofSalesbyYearSearchComponent }  from './SummaryofSalesbyYearSearch.component';

@Component({
	selector: 'my-SummaryofSalesbyYear',
	template: require('./SummaryofSalesbyYearList.component.html'),
	providers: [SummaryofSalesbyYearService],
	animations: [
    trigger('routeAnimation', [
      state('*',
        style({
          opacity: 1,
          transform: 'translateX(0)'
        })
      ),
      transition(':enter', [
        style({
          opacity: 0,
          transform: 'translateX(-100%)'
        }),
        animate('0.4s ease-in')
      ]),
      transition(':leave', [
        animate('0.7s ease-out', style({
          opacity: 0,
          transform: 'translateY(100%)'
        }))
      ])
    ])
  ]
})

export class SummaryofSalesbyYearListComponent implements OnInit {
	@HostBinding('@routeAnimation') get routeAnimation() {
		return true;
	}

	@HostBinding('style.display') get display() {
		return 'block';
	}
	
	SummaryofSalesbyYearList: SummaryofSalesbyYearData[];
	newSummaryofSalesbyYear: SummaryofSalesbyYearData;
	selectedSummaryofSalesbyYear: SummaryofSalesbyYearData;
	errorMessage: string;
	messages: string[];
	showAdd: boolean;
	@ViewChild(SummaryofSalesbyYearSearchComponent) filterComponent: SummaryofSalesbyYearSearchComponent;

	sortExpression: string = "ShippedDate";
	filterExpression: string = "";
	pageIndex: number = 1;
	pageSize: number = 10;
	endRowIndex: number;
	rowsCount: number;
	pageCount: number;
	isFirstPage: boolean;

    private selectedId: string;

	constructor(
		private SummaryofSalesbyYearService: SummaryofSalesbyYearService,
		private route: ActivatedRoute,
		private router: Router,
		private toastr: ToastsManager
	) {
		this.newSummaryofSalesbyYear = new SummaryofSalesbyYearData();
		this.pageSize = myGlobals.pageSize;
	}

	ngOnInit() {
		// this.SummaryofSalesbyYearService.getAll().subscribe(record => this.SummaryofSalesbyYearList=record);
		this.pageIndex = 1;
		this.isFirstPage = true;
		this.getSummaryofSalesbyYearByPaging();

		/*
		this.SummaryofSalesbyYearList = this.route.params
			.switchMap((params: Params) => {
				this.selectedId = +params['id'];
				return this.service.getAll();
			});
		*/
	}

	// Get all records
	public getSummaryofSalesbyYear() {
		this.SummaryofSalesbyYearService.getAll()
			.subscribe(data => this.SummaryofSalesbyYearList = data,
		error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error);
	}
	
	// On Search CLick on SummaryofSalesbyYearSearch Component
	onSearch(searchText: string) {
		// 1. Update this.filterExpression
		this.filterExpression = searchText;

		// 2. call getSummaryofSalesbyYearByPaging method that will refresh the data
		this.pageIndex = 1;
		this.getSummaryofSalesbyYearByPaging();
	}
	
	onSort(event, sortColumn: string)
	{
		// var target = event.target || event.srcElement || event.currentTarget;
		// var parent = target.parentNode;
		if (this.sortExpression === sortColumn)
			this.sortExpression = sortColumn + ' desc';
		else if (this.sortExpression === sortColumn + ' desc')
			this.sortExpression = sortColumn;
		else
			this.sortExpression = sortColumn;
		this.getSummaryofSalesbyYearByPaging();
	}
	
	// Get records by paging
	getSummaryofSalesbyYearByPaging() {
		this.SummaryofSalesbyYearService.getAllByPaging(this.filterExpression, this.sortExpression, this.pageIndex, this.pageSize)
			.subscribe(data => {
				this.SummaryofSalesbyYearList=data.SummaryofSalesbyYearList;
				this.rowsCount=data.RowsCount; 
				this.pageCount= Math.ceil(this.rowsCount / this.pageSize);
				if (this.pageIndex == 1)
					this.isFirstPage = true;
				else
					this.isFirstPage = false;
				if (this.pageIndex == this.pageCount)
					this.endRowIndex = this.rowsCount;
				else
					this.endRowIndex = this.pageIndex * this.pageSize;
			},
			error =>  this.errorMessage = 'There was an error while retrieving records. Error: ' + <any>error
		);
	}
	// Adds new record
	addSummaryofSalesbyYear() {
		this.SummaryofSalesbyYearService.addSummaryofSalesbyYearData(this.newSummaryofSalesbyYear).subscribe(record => console.log(record));
		this.getSummaryofSalesbyYear();
	}
  
	// Updates existing record
	updateSummaryofSalesbyYear() {
		this.SummaryofSalesbyYearService.updateSummaryofSalesbyYearData(this.selectedSummaryofSalesbyYear).subscribe(record => console.log(record));
		this.getSummaryofSalesbyYear();
	}

	// Deletes record with specified id
	deleteSummaryofSalesbyYear(id: string) {
		if (window.confirm('Are you sure you want to delete this SummaryofSalesbyYear?') == true)
		{
			this.SummaryofSalesbyYearService.deleteSummaryofSalesbyYear(id)
			.subscribe(data => this.getSummaryofSalesbyYear(), 
			error =>  this.errorMessage = 'There was an error while deleting record. Error: ' + <any>error);
		}
	}

	// Go to First Page
	onFirstPage() {
		this.pageIndex = 1;
		this.getSummaryofSalesbyYearByPaging();
	}

	// Go to Previous Page
	onPreviousPage() {
		if (this.pageIndex > 1) {
			this.pageIndex = this.pageIndex - 1;
			this.getSummaryofSalesbyYearByPaging();
		}
	}

	// Go to Next Page
	onNextPage() {
		if (this.pageIndex < this.pageCount) {
			this.pageIndex = this.pageIndex + 1;
			this.getSummaryofSalesbyYearByPaging();
		}
	}

	// Go to Last Page
	onLastPage() {
		this.pageIndex = this.pageCount;
		this.getSummaryofSalesbyYearByPaging();
	}

	// Refresh - Go to First Page
	onRefresh() {
		this.onFirstPage();
	}

	// On Edit - Go to Edit page
	onSelect(item: SummaryofSalesbyYearData) {
		this.router.navigate(['/SummaryofSalesbyYear', item.ShippedDate]);
	}

	// On Details - Go to Details page
	onSelectDetails(item: SummaryofSalesbyYearData) {
		this.router.navigate(['/SummaryofSalesbyYear/Details', item.ShippedDate]);
	}

	// Set record as selected
	SelectSummaryofSalesbyYear(item: SummaryofSalesbyYearData) {
		this.selectedSummaryofSalesbyYear = item;
	}

	// Submits form
	submitForm(data: Object) {
		console.log(data);
	}

	// Logs message onto Console
	log(msg: string) {
		this.messages.splice(0, 0, msg);
		console.log(msg);
	}

/*
	isSelected(item: SummaryofSalesbyYearData) {
		return item.ShippedDate === this.selectedId;
	}
*/
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/SummaryofSalesbyYear/SummaryofSalesbyYearList.component.ts